import React from 'react'
import Link from 'next/link'
import { Logo } from '~shared/components/logo'
// import { Button } from '~shared/components/button'
import { SearchIcon } from '~shared/icons/search'
import { Drawer, DrawerTrigger } from '@/modules/components/ui/drawer'
import { HeaderDrawer } from './header-drawer'
import { getPopularPrograms } from '~shared/api/programs-popular/getPopularPrograms'
import { getCategoriesData } from '~shared/api/categories/getCategories'

import { Button } from '~shared/components/button-v2'
import { LogoHeaderMobile } from '~shared/components/logo-header-mobile'
import { BurgerMenuDrawer } from './burger-menu-drawer'
import { useBreakpoint } from '~shared/hooks/useBreakpoint'

type HeaderProps = {
  categories: Awaited<ReturnType<typeof getCategoriesData>>
  popularPrograms: Awaited<ReturnType<typeof getPopularPrograms>>
}

export const Header: React.FC<HeaderProps> = ({
  categories,
  popularPrograms
}) => {

  const breakpoint = useBreakpoint()
  return (
    <header className='pt-[60px] pb-[30px] md:pt-[24px] md:pb-[40px]'>
      <div className='container container-slim'>
        <div className='justify-between items-center flex'>
          <div className='flex md:gap-[24px] lg:gap-[40px] items-center w-full lg:w-auto'>
            <Link href='/'>
              <Logo
                id='Header'
                className='text-tertiary hidden md:inline-block'
              />
              <LogoHeaderMobile className='md:hidden' />
            </Link>

            <Drawer direction='top' handleOnly={breakpoint === 'xs'}>
              <DrawerTrigger asChild>
                <Button
                  size='sm'
                  variant='secondary'
                  className='px-[16px] gap-[8px] h-[45px] text-[14px] ml-auto md:ml-0  mr-[4px] md:h-[35px] md:text-[16px] '>
                  <SearchIcon /> каталог курсов
                </Button>
              </DrawerTrigger>
              <HeaderDrawer
                categories={categories}
                popularPrograms={popularPrograms}
              />
            </Drawer>

            <Drawer direction='right'>
              <DrawerTrigger asChild>
                <Button
                  size='sm'
                  variant='primary'
                  className='px-[16px] text-[14px] lg:hidden hidden md:inline-block md:ml-auto'>
                  Меню
                </Button>
              </DrawerTrigger>
              <DrawerTrigger asChild>
                <Button
                  variant='primary'
                  className='px-[16px] w-[45px] h-[45px] text-[14px] md:hidden flex-col gap-[5px]'>
                  {Array.from({ length: 3 }).map((_, index) => (
                    <span
                      className='block w-[13px] h-[1px] bg-white'
                      key={index}
                    />
                  ))}
                </Button>
              </DrawerTrigger>
              <BurgerMenuDrawer categories={categories} />
            </Drawer>
          </div>
          <div className='items-center gap-10 hidden lg:flex'>
            <a href='tel:+7(800)333-71-38' className='text-right'>
              <p className='text-[10px] text-[#8B8B8B] mb-2'>
                Бесплатно по России
              </p>
              <p className='text-[14px] font-medium'>+7 (800) 444-81-38</p>
            </a>
            <a href='tel:+7(495)648-62-23' className='text-right'>
              <p className='text-[10px] text-[#8B8B8B] mb-2'>
                Бесплатно по Москве
              </p>
              <p className='text-[14px] font-medium'>+7(495)648-62-23</p>
            </a>
          </div>
        </div>
        <nav
          className='mt-[40px] hidden lg:block font-medium'
          itemScope
          itemType='https://schema.org/SiteNavigationElement'>
          <ul className='flex justify-between gap-5 max-w-[933px] mx-auto'>
            {categories?.categories?.map(el => (
              <li key={el.name} className='hover:underline'>
                <Link href={el.slug ?? ''} itemProp='url'>
                  <span itemProp='name'>{el.name}</span>
                </Link>
              </li>
            ))}
            <li className='text-[#3A52EE] hover:underline'>
              <Link href='/journal' itemProp='url'>
                <span itemProp='name'>Журнал</span>
              </Link>
            </li>
            <li className='text-[#3A52EE] hover:underline'>
              <Link href='/contact' itemProp='url'>
                <span itemProp='name'>Контакты</span>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}
